<template>
    <div class="bto-sb-event-odds">
        <div class="bto-sb-event-odds-left">
            <div v-if="$parent.showEventCode" class="bto-sb-event-code">{{match.eventCode}}</div>
            <div class="bto-sb-event-time">
                <span class="bto-sb-event-inntime">{{match.time}}</span>
                <span class="bto-sb-event-inndate">{{match.date}}</span>
            </div>
            <div class="bto-sb-event-name">
                <router-link :to="$parent.openMatchDetails(match)">
                    <div class="bto-sb-event-wrap">
          <span class="bto-sb-event-team">
            <logo-component v-if="$parent.showTeamIcon" v-slot="{ url, reset }" :logo-url="match.homeTeamIcon" >
              <span class="bto-sb-event-team-logo bto-sb-event-hometeam-logo" v-if="url">
                <img :src="url" alt="" @error="reset" />
              </span>
            </logo-component>
            <span class="bto-sb-event-home">{{match.homeTeam}}</span>
          </span>
        <span class="bto-sb-event-score-vs">{{t('Mobile.VS')}}</span>
        <span class="bto-sb-event-team">
            <logo-component v-if="$parent.showTeamIcon" v-slot="{ url, reset }" :logo-url="match.guestTeamIcon" >
              <span class="bto-sb-event-team-logo bto-sb-event-awayteam-logo" v-if="url">
                <img :src="url" alt="" @error="reset" />
              </span>
            </logo-component>
            <span class="bto-sb-event-away">{{match.guestTeam}}</span>
        </span>
                    </div>
                    <div v-if="$parent.eventDescription !== ''" class="bto-sb-event-description">
                        {{$parent.eventDescription}}
                    </div>
                </router-link>
            </div>
        </div>
        <div class="bto-sb-event-odds-right">
            <div class="bto-sb-event-odds-info-cell">
                <favorite-component v-if="showFavorites" :match="match"/>
                <statistics-component :betRadarId="match.betRadarId" :feedProvider="match.feedProvider" v-if="$parent.showStatistics" :isAwayAtHome="match.awayAtHome" :isLive="match.isLiveMatch" :sportId="match.sportId" :tournamentName="match.tournamentName" />
            </div>
            <div v-if="!singleMarketSelected" class="bto-sb-event-odds-cell">
                <match-odd-component :match="match" :odd="match.odds[0]"
                                     :outcome="$parent.genarateOutcomeDisplay(match,0)"/>
                <match-odd-component v-if="is3WaySport" :match="match" :odd="match.odds[0]"
                                     :outcome="$parent.firstCol.outcomes.length > 2 ? $parent.genarateOutcomeDisplay(match,1) : $parent.generateEmptyOdd()"/>
                <match-odd-component :match="match" :odd="match.odds[0]"
                                     :outcome="$parent.firstCol.outcomes.length > 2 ? $parent.genarateOutcomeDisplay(match,2) : $parent.genarateOutcomeDisplay(match,1)"/>
            </div>
            <div v-if="!singleMarketSelected && Object.keys(combiMainMarkets).length && combiMainMarkets.hasOwnProperty(1)"
                 class="bto-sb-event-odds-cell bto-sb-md-none">
      <span
              v-if="firstCombiOdds[match.matchId] && firstCombiOdds[match.matchId].outcomes[0].sbv"
              class='bto-sb-event-odd bto-sb-odd-special'
      >
        {{firstCombiOdds[match.matchId].outcomes[0].sbv}}
      </span>
                <match-odd-component
                        v-for="(outcome, idx) in $parent.secondCol.outcomes"
                        :key="idx"
                        :match="match"
                        :odd="$parent.secondCol"
                        :outcome="outcome"
                />
            </div>
            <div v-if="!singleMarketSelected && Object.keys(combiMainMarkets).length && combiMainMarkets.hasOwnProperty(2)"
                 class="bto-sb-event-odds-cell bto-sb-lg-none">
      <span v-if="secondCombiOdds[match.matchId] && secondCombiOdds[match.matchId].outcomes[0].sbv"
            class='bto-sb-event-odd bto-sb-odd-special'>
        {{secondCombiOdds[match.matchId].outcomes[0].sbv}}
      </span>
                <match-odd-component
                        v-for="(outcome, idx) in $parent.thirdCol.outcomes"
                        :key="idx"
                        :match="match"
                        :odd="$parent.thirdCol"
                        :outcome="outcome"/>
            </div>
            <div v-if="singleMarketSelected && singleMarketOdds"
                 class="bto-sb-event-odds-cell bto-sb-event-odds-cell-col">
      <span class="bto-sb-event-odd-col"
            v-for="(dummy, idx) in new Array(Math.max(...singleMarketOdds.outcomes.map(o => o.column)))"
            :key="idx">
        <match-odd-component
                v-for="(outcome, key) in $parent.getOrderedOutcomes(idx+1)"
                :key="key"
                :match="match"
                :odd="singleMarketOdds"
                :outcome="outcome"
                :isDetails="true"
                :lockEmptyOdd="false"/>
      </span>
            </div>
            <div
                    class="bto-sb-event-odds-cell bto-sb-event-more-odd"
                    :class="{
                        'bto-sb-event-more-odd-active' : $parent.matchExpanded === true,
                        'bto-sb-event-more-cash' : $parent.cashOutVisibility}"
                    @click="$parent.toggleDetails()"
            >+{{$parent.SHOW_NUMBER_OF_MARKETS ? match.numberOfMarkets : match.numberOfOdds}}
            <i class="bto-app-cash" v-if="$parent.cashOutVisibility"></i>
            </div>
        </div>
        <embeded-match-details
                v-if="$parent.matchExpanded"
                :matchIdProp="match.matchId"
                :matchTypeProp="match.isLiveMatch ? 'live' : 'prematch'"
                @toggleDetails="$emit('toggleDetails')"
        />
    </div>
</template>
<script>
  import MatchListProps from '../match-list-props';

  export default {
    name: 'MatchListItemTpl',
    props: MatchListProps
  };
</script>


